import { Box, SimpleGrid } from "@chakra-ui/react";
import ProjectForm from "./components/Form";
import GestaoTable from "./components/Table";
import useProject from "./hooks/useProject";
import { ConditionalRenderer } from "../components/ConditionalRenderer";
import { SimpleConditionalFrame } from "../components/SimpleConditionalFrame";

const ProjectScreen = () => {

  const {
    list1,
    loading,
    selectedOrder1,
    show1,
    usuario,
    showModal1,
    contatoAgencia1,
    contatoCliente1,
    users,
    clients

  } = useProject();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} overflowY={"scroll"}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show1,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal1(false, null)}
                title="Gestão Executiva do Projeto"
              >
                <ProjectForm
                  accountSelected={selectedOrder1}
                  loading={loading}
                  show={show1}
                  showModal={showModal1}
                  contatoAgencia={contatoAgencia1}
                  contatoCliente={contatoCliente1}
                  users={users}
                  clients={clients}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <GestaoTable list={list1} showModal={showModal1} />
          </SimpleGrid>
        )}
      />
    </Box>
  )
}
export default ProjectScreen;